var _ = require('underscore');
var Backbone = require('backbone');
var ConsultationMock = require('Consultation');
var Dropdown = require('Dropdown');

module.exports.describe = function () {
    describe('Dropdown', function () {            
        var options = {
            collection: new Backbone.Collection([{ id: 1, name: 'First' }, { id: 2, name: 'Second' }]),
            selection: 2
        };
        var proto = Dropdown.View.prototype;

        beforeAll(function (done) {
            spyOn(proto, 'selectionChanged').and.callThrough();
            spyOn(proto, 'onSelectionChanged').and.callThrough();

            ConsultationMock.show({ view: new Dropdown.View(options) });

            setTimeout(function () {
                done();
            }, 1000);
        });

        it('fires selectionChanged()', function () {
            expect(proto.selectionChanged).toHaveBeenCalled();
        });

        it('fires onSelectionChanged()', function () {
            expect(proto.onSelectionChanged).toHaveBeenCalled();
        });

        it('reflects proper selection', function () {                
            var model = _.first(proto.onSelectionChanged.calls.first().args);
                
            expect(options.selection).toEqual(model.id);
        });
    });
};


// WEBPACK FOOTER //
// ./test/Specs/Unit/Dropdown.js